import BindDesktopModal from './BindDesktopModal';

export default BindDesktopModal;
